// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"customizedItemsCard_itemContainer__2Bf7X","itemList":"customizedItemsCard_itemList__2K1En"};